export const crmLang = {
	label: {
		crm: 'Hubspot Options',
		slack: 'Slack Options',
		finalizeSale: 'Finalize Sale',
		saveQuote: 'Save Quote',
		passOff: 'Submit Blueprint',
		associateDeal: 'Associated Deal',
		createDeal: 'Create New Deal',
		dealName: 'Deal Name',
		address: 'Address',
		city: 'City',
		state: 'State',
		zip: 'Zip Code',
		depositLinkSet: 'Deposit link',
		depositLinkMissing: 'No deposit link'
	},
	tooltip: {
		disabledCrm: 'CRM features require a customer to be loaded. Use the "Find Customer" button in the toolbar to search by email or name.',
		disabledSlack: 'Slack features require a customer with an active HubSpot deal. Load a customer using the "Find Customer" button, then ensure they have at least one deal in HubSpot.',
		disabledFinalizeSale: 'To finalize a sale: (1) Save a quote using the "Save Quote" button, and (2) the deal must have a "Deposit Received" status in HubSpot.',
		finalizeSale: 'Click to Finalize Sale',
		generateQuote: 'Click here to generate a quote',
		noDealId: 'A HubSpot deal is required to save a quote. Use the "Associated Deal" button to create or select a deal for this design.',
		noQuoteData: 'There is no pricing data to generate a quote. Add appliances or items to your design so the MSRP subtotal is greater than zero.',
		openCrmFeatures: 'Open Hubspot Options',
		openSlackFeatures: 'Open Slack Options',
		passOff: 'Submit blueprint and quote to HubSpot',
		passOffDisabled: 'Complete all checklist items to enable submission',
		passOffMissingName: 'Please enter your name to submit',
		passOffMissingChecklist: 'All checklist items must be confirmed before submitting: fuel source, island dimensions, countertop dimensions, and utility cutouts.',
		passOffMissingProjectFolder: 'Project Folder Link is required. Paste the Google Drive link before submitting.',
		passOffMissingCustomer: 'Blueprint submission requires a customer to be loaded. Use the "Find Customer" button in the toolbar to search by email or name.',
		passOffFuelSourceWarning: 'At least one appliance is missing a fuel source selection (Natural Gas or Propane). Open the appliance properties and set a fuel source for each appliance before submitting.',
		passOffWillSubmitQuote: 'This will also submit a quote to HubSpot',
		associateDeal: 'Associate a HubSpot deal with this design',
		associateDealPending: 'Saving deal association…',
		disabledAssociateDeal: 'A customer must be loaded before you can associate a HubSpot deal. Use the "Find Customer" button in the toolbar to search by email or name.',
		depositLinkSet: 'This deal has a Deposit Link in HubSpot, so the design package’s "Pay Deposit" button will be clickable.',
		depositLinkMissing: 'This deal has no Deposit Link in HubSpot. The design package will show "Deposit link not generated" and the "Pay Deposit" button will not be clickable. A newly created deal can take a moment to be issued one — reload the customer to re-check.'
	},
	text: {
		noDealsFound: 'No deals found for this customer. Create a new deal to get started.',
		designerUnassigned: 'Unassigned'
	},
	message: {
		dealAssociationFailed: 'Failed to save the deal association. Please try again.',
		dealAssociationMissingContext: 'Unable to save the deal association: no design or customer is loaded. Please reload and try again.',
		quoteCreated: 'Quote was created for deal:',
		quoteLineItemsAutomated: 'The deal\u2019s line items and Amount are updated automatically from this quote \u2014 there is no longer any need to add them to the deal by hand. Any you entered manually before will still be there alongside these and should be removed once.',
		quoteCreationFailed: 'Quote creation failed',
		createDealFailed: 'Failed to create deal. Please try again.',
		passOffSent: 'Blueprint submitted successfully',
		passOffFailed: 'Failed to submit blueprint',
		passOffAndQuoteSent: 'Blueprint and quote submitted successfully',
		depositLinkMissingOnGenerate: 'No HubSpot Deposit Link on any of this customer’s deals — the design package’s "Pay Deposit" button will not be clickable.',
		depositLinkFallbackOnGenerate: 'This deal has no HubSpot Deposit Link — the design package will fall back to another of this customer’s deals for the "Pay Deposit" button.'
	},
	passOffChecklist: {
		fuelSource: 'Fuel source is correct',
		dimensions: 'Confirm dimensions of islands/countertops',
		overhangs: 'Confirm overhangs of countertops',
		utilityCutouts: 'Confirm all Utility Cutouts'
	}
};
